module.exports = __webpack_public_path__ + "static/media/LogoExitfund.d5399ae4.svg";